(() => {
  if (window.__ossMobileLocalizationInlineV4Installed) return;
  window.__ossMobileLocalizationInlineV4Installed = true;

  const MOBILE_QUERY = '(max-width: 768px)';
  const FORM_SELECTOR = '.header-localization--mobile .oss-mobile-localization-form';
  const TOGGLE_SELECTOR = '[data-oss-mobile-localization-toggle]';
  const PANEL_SELECTOR = '[data-oss-mobile-localization-panel]';
  const OPTION_SELECTOR = '[data-oss-mobile-localization-option]';

  const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;

  const forms = () => Array.from(document.querySelectorAll(FORM_SELECTOR));

  const closePanel = (form, kind) => {
    if (!form) return;
    const toggle = form.querySelector(`${TOGGLE_SELECTOR}[data-oss-mobile-localization-toggle="${kind}"]`);
    const panel = form.querySelector(`${PANEL_SELECTOR}[data-oss-mobile-localization-panel="${kind}"]`);
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
  };

  const closeAll = (exceptForm = null, exceptKind = '') => {
    forms().forEach((form) => {
      ['language', 'country'].forEach((kind) => {
        if (form === exceptForm && kind === exceptKind) return;
        closePanel(form, kind);
      });
    });
    syncBodyState();
  };

  const centerSelected = (panel) => {
    if (!panel || panel.hidden || panel.clientHeight <= 0) return;
    const selected = panel.querySelector(`${OPTION_SELECTOR}[aria-selected="true"]`);
    if (!selected) return;

    const maxScroll = Math.max(0, panel.scrollHeight - panel.clientHeight);
    const target = selected.offsetTop - ((panel.clientHeight - selected.offsetHeight) / 2);
    panel.scrollTop = Math.max(0, Math.min(maxScroll, target));
  };

  const syncBodyState = () => {
    const open = isMobile() && forms().some((form) =>
      Array.from(form.querySelectorAll(PANEL_SELECTOR)).some((panel) => !panel.hidden)
    );
    document.documentElement.classList.toggle('oss-mobile-localization-open', open);
    document.body?.classList.toggle('oss-mobile-localization-open', open);
  };

  const openPanel = (form, kind) => {
    if (!form || !isMobile()) return;
    const toggle = form.querySelector(`${TOGGLE_SELECTOR}[data-oss-mobile-localization-toggle="${kind}"]`);
    const panel = form.querySelector(`${PANEL_SELECTOR}[data-oss-mobile-localization-panel="${kind}"]`);
    if (!toggle || !panel) return;

    closeAll(form, kind);
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    syncBodyState();

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => centerSelected(panel));
    });
  };

  const togglePanel = (form, kind) => {
    const panel = form?.querySelector(`${PANEL_SELECTOR}[data-oss-mobile-localization-panel="${kind}"]`);
    if (!panel) return;
    if (panel.hidden) openPanel(form, kind);
    else {
      closePanel(form, kind);
      syncBodyState();
    }
  };

  const submitSelection = (form, option) => {
    const kind = option.dataset.ossMobileLocalizationKind;
    const value = option.dataset.value;
    if (!form || !kind || !value) return;

    const inputName = kind === 'language' ? 'locale_code' : 'country_code';
    const input = form.querySelector(`input[name="${inputName}"]`);
    if (!input) return;

    input.value = value;
    option.setAttribute('aria-selected', 'true');
    HTMLFormElement.prototype.submit.call(form);
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const toggle = target.closest(TOGGLE_SELECTOR);
    if (toggle) {
      const form = toggle.closest('form');
      if (!form?.matches(FORM_SELECTOR) || !isMobile()) return;
      event.preventDefault();
      event.stopPropagation();
      togglePanel(form, toggle.dataset.ossMobileLocalizationToggle || '');
      return;
    }

    const option = target.closest(OPTION_SELECTOR);
    if (option) {
      const form = option.closest('form');
      if (!form?.matches(FORM_SELECTOR) || !isMobile()) return;
      event.preventDefault();
      event.stopPropagation();
      submitSelection(form, option);
      return;
    }

    if (!target.closest(FORM_SELECTOR)) closeAll();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  window.addEventListener('resize', () => {
    if (!isMobile()) closeAll();
  }, { passive: true });

  window.addEventListener('orientationchange', () => {
    window.setTimeout(() => {
      if (!isMobile()) closeAll();
      else {
        forms().forEach((form) => {
          const panel = Array.from(form.querySelectorAll(PANEL_SELECTOR)).find((node) => !node.hidden);
          if (panel) centerSelected(panel);
        });
      }
    }, 100);
  });
})();
